// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';


const firebaseConfig = {
  apiKey: "AIzaSyCyySvp6kcdoo4BL0mN8Bd8wFJF5K-nljg",
  authDomain: "tel-react.firebaseapp.com",
  projectId: "tel-react",
  storageBucket: "tel-react.appspot.com",
  messagingSenderId: "607754914037",
  appId: "1:607754914037:web:d89b51055aa8e281f41dbc"
};

// אתחול Firebase
const app = initializeApp(firebaseConfig);

// יצירת instances
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;